<template>
	<div class="ng-scope show-sticky-calc" :class="openSelect ? 'modal-open' : ''" @click="closeSelectExpand">
		<headerNavigation ref="headerRef" :isHome="true" @openLoginMadal="openLoginMadal" @changeRegister="changeRegister"></headerNavigation>
		<template v-if="isMobile">
			<div class="global-header-spacer display-mobile" style="height: 0px;" ></div>
			<div class="div-after-fixed-header" style="height: 103px;"></div>
		</template>
		<div class="page-content-container">
			<div class="page-product-container">
				<div class="main-contents-container container">
					<div class="breadcrumb-container">
						<div class="comp-breadcrumbs-container">
							<ul class="breadcrumbs-list clearfix breadcrumbs-not-empty">
								<li class="breadcrumb-list-item active">
									<a href="javascript:void()" @click="openPage('/')" class="site-secondary-link breadcrumb-link breadcrumb1">{{$t('common.home')}}</a>
								</li>
								<li class="breadcrumb-list-item ">
									<span class="breadcrumb-active-label breadcrumb2">{{productInfos.productname}}</span>
								</li>
							</ul>
						</div>
					</div>
					<div class="gallery-calculator-container row">
						<div class="product-gallery-column col-md-11">
							<div class="gallery-product-region">
								<div class="product-gallery-widget accessibility">
									<div class="comp-gallery-container">
										<div class="sms-wgt-gallery js-gallery-toggle thumbnail-buckets">
											<div class="wgt-gallery-main-image">
												<div class="main-image-container js-gallery-main-image-carousel owl-theme owl-carousel owl-loaded">
													<div class="owl-stage-outer">
														<div class="owl-stage">
															<div class="owl-item">
																<div class="main-image-wrapper">
																	<div class="slide-352 default-gallery zoom-image-container">
																		<el-image v-if="swiperList.length > 0" :src="swiperList[dotIndex]"  :preview-src-list="swiperList" class="main-image" style="width: 100%;"></el-image>
																		<!-- <img class="main-image" width="100%" :src="swiperList[dotIndex]"> -->
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div class="wgt-gallery-thumbnail-group gallery-product">
												<div class="js-gallery-thumbnails-carousel owl-theme owl-carousel format-carousel-navigation owl-loaded owl-drag">
													<div class="owl-nav js-gallery-thumbnails-carousel-detached owl-nav-left" v-if="!isMobile">
														<button type="button" class="owl-prev" :class="dotIndex == 0 ? 'disabled' : ''" @click="swiperPrev">
															<img class="arrow-left" src="../../assets/images/arrow-left-icon.svg">
														</button>
													</div>
													<template v-if="isMobile">
														<div class="owl-stage-outer" ref="owllist">
															<div ref="owlBox" data-startX="0" data-currentX="0" data-translateX="0" @touchstart="handleTouchStart($event)" @touchmove="handleTouchMove($event)" @touchend="handleTouchEnd($event)" class="owl-stage" style="transform: translate3d(0px, 0px, 0px); transition: all; ">
																<div :ref="'owlItems'+index" class="owl-item active" :style="mobileSwiperStyle" v-for="(item,index) in swiperList" :key="index" @click="selectSwiper(index)">
																	<div class="accessibility-item thumbnail-slide-352 thumbnail-item thumbnail-215 default-image" :class="dotIndex == index ? 'active' : ''">
																		<img class="thumbnail-images" width="100%" :src="item">
																	</div>
																</div>
															</div>
														</div>
													</template>
													<template v-else>
														<div class="owl-stage-outer" ref="owllist">
															<div ref="owlBox" class="owl-stage" style="transform: translate3d(0px, 0px, 0px); transition: all; width: 1158px;">
																<div :ref="'owlItems'+index" class="owl-item active" style="width: 102.75px; margin-right: 13px;" v-for="(item,index) in swiperList" :key="index" @click="selectSwiper(index)">
																	<div class="accessibility-item thumbnail-slide-352 thumbnail-item thumbnail-215 default-image" :class="dotIndex == index ? 'active' : ''">
																		<img class="thumbnail-images" width="100%" :src="item">
																	</div>
																</div>
															</div>
														</div>
													</template>
													<div class="owl-nav" v-if="!isMobile">
														<button type="button" role="presentation" class="owl-next" :class="dotIndex >= swiperList.length - 1 ? 'disabled' : ''" @click="swiperNext">
															<img class="arrow-right" src="../../assets/images/arrow-right-icon.svg">
														</button>
													</div>
													<div class="owl-dots disabled"></div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="sms-wgt-text-image scroll-lazy wgt-txt-list_styles-check_list_primary wgt-txt-list_display_styles-list_group_inline lazy-loaded">
								    <div class="wgt-text-content">
								        <ul>
											<li v-for="(item,index) in productInfos.featureTags">{{item}}</li>
										</ul>            
									</div>
								</div>
							</div>
						</div>
						<div class="pdp-box-wrap col-md-13">
							<div class="product-heading-features-container product-heading-calc-wrap has-gallery">
							    <div class="heading-product-region">
									<h1 class="url-set-heading">{{productInfos.productname}}</h1>                    
									<div class="inline-rating-wrapper js-inline-rating-container">
										<div class="comp-inline-product-rating-container">
											<div class="inline-product-rating-summary">
												<div class="ratings-in-stars comp-ratings-in-stars-container">
													<div class="fill-star-ratings">
														<img src="../../assets/images/star.png" v-for="item in Number(productInfos.startype)"/>
													</div>
												</div>
												<div class="total-ratings" style="padding-top: 4px;">{{productInfos.plnum}} {{$t('product.reviews')}}</div>
											</div>
										</div>
									</div>
							    </div>
							</div>
							<div id="calculator_handler" class="product-calculator-column ng-isolate-scope">
								<div class="list-standard list">
									<div class="mobile-order-button-container hidden-lg hidden-md hidden-sm" v-if="isMobile">
										<button @click="addCart" class="site-btn-primary order-button ng-isolate-scope"> 
											<span class="button-label">{{$t('product.addtocart')}}</span> 
										</button>
									</div>
									<div class="calculator-shipping-container">
										<div class="calculator-product-region">
											<div v-for="(item,index) in attributeData" :key="index" class="comp-multi-calc-switch-group-container ng-multi-calc-switch-group-container" style="margin-bottom: 8px;">
												<div class="comp-multi-calc-switch-box-container box-3">
													<label class="multi-calc-label ng-scope" :class="lang == 'zh' ? 'multi-calc-label-zh' : ''">
														<span class="ng-binding">{{item.groupName}}：</span>
													</label>
													<div class="multi-calc-items" :class="lang == 'zh' ? 'multi-calc-items-zh' : ''">
														<div class="multi-calc-button-container ng-scope" v-for="(attribute,attributeIndex) in item.productAttributeGroupI18nValueList" :key="attributeIndex">
															<div class="multi-calc-button odd" :class="attrSKU[index].valueCode == attribute.attributeKey ? 'active' : ''" @click="selectSku(index,attribute)">
																<div class="calc-details">
																	<span class="calc-button-label ng-binding">{{attribute.attributeValue}}</span>
																</div>
																<img src="../../assets/images/check.png" v-if="attrSKU[index].valueCode == attribute.attributeKey" class="active-multi-calc-btn-icon check-iocn" style="display: block;"/>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div class="calc-content">
												<div class="calc-instance comp-product-calculator-tradpricegroup-container">
													<div class="calculator ng-pristine ng-valid">
														<div class="calc-group">
															<div class="price-group-section">
																<!-- <div>
																	<div class="calc-attr dropdown-attr-6">
																		<label class="calculator-label">
																			<span>{{$t('product.printingtime')}}<span class="colon hidden">：</span></span>
																		</label>
																		<div class="attr-container">
																			<div class="site-dropdown site-dropdown-group dropdown ">
																				<button class="btn dropdown-toggle val-wrap " type="button">
																					<span class="dropdown-toggle-label">6个工作日</span>
																					<span class="unit-discount-container">
																						<span class="selected-addon-price"></span>
																						<span class="selected-addon-discount"></span>
																					</span>
																					<img src="../../assets/images/arrow-down.png" class="dropdown-toggle-icon fa fa-angle-down a-down-icon"/>
																				</button>
																				<ul class="dropdown-menu menu-parent">
																					<li class="blurb-list-dropdown dropdown-menu-item">
																						<a class="attr-value val-wrap ">
																							<span class="val">
																								<span class="dropdown-link-text">
																									<div class="badge-blurb-container">
																										<span>6个工作日</span>
																									</div> 
																								</span>
																							</span>
																							<img src="../../assets/images/check.png" class="check-iocn"/>
																						</a>
																					</li>
																				</ul>
																			</div>
																		</div>
																	</div>
																</div> -->
																<div class="price-config-wrapper">
																	<div class="comp-product-calculator-price-container">
																		<span class="subtotal-label">{{$t('product.printingcost')}}</span>
																		<span class="subtotal-container"> 
																			<span class="calc-price subtotal-price" v-if="lang == 'zh'">{{skuPrice}} 美元</span> 
																			<span class="calc-price subtotal-price" v-else>${{skuPrice}}</span> 
																			<!-- <template v-if="!isMobile">
																				<span class="calc-discounted-price discounted-price hidden"></span>
																				<div class="calc-price-per-piece ">（每人 4.18 美元）</div> 
																			</template> -->
																			
																		</span>
																	</div>
																</div>
																<div class="design-draft-wrapper" v-if="designDraftList.length > 0">
																	<div class="design-draft-header">{{$t('product.uploadedfile')}}</div>
																	<div class="design-draft-region">
																		<div class="design-draft-item" v-for="(item,index) in designDraftList">
																			<img :src="item" class="design-draft-img"/>
																			<div class="desigin-action">
																				<img src="../../assets/images/del2.png" class="u-del-icon" @click="delDesign(index)"/>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div class="sms-wgt-btn upload-btn-container" v-if="isMobile">
												<div class="button-wrapper">
													<button @click="addCart" class="site-btn-primary upload-btn site-btn-secondary-no-radius display-block btn btn-default btn-lg upload-cta-type ng-isolate-scope">
														<span class="btn-text-container">{{$t('product.addtocart')}}</span>
													</button>
												</div>
											</div>
											<div class="ex9253-wrapper" v-if="!isMobile">
												<div class="flex-col">
													<button class="exbtn-upload">
														<input type="file" class="upload-input-s" accept="image/*" @change="onFileChange"/>
														<span>
															<i class="ex-icon-upload"></i>
															<strong>{{$t('product.uploaddesign')}}</strong> 
														</span>
													</button>
													<button class="exbtn-design" @click="addCart">
														<span>
															<strong>{{$t('product.addtocart')}}</strong>
														</span>
													</button>
												</div>
											</div>
										</div>
									</div>
									<!-- <div class="calculator-bottom-container" v-if="!isMobile">
										<div class="calculator-bottom-product-region">
											<div class="sms-wgt-btn upload_later-btn-container">
												<div class="button-wrapper">
													<button class="link-display upload_later-btn site-btn-secondary-no-radius display-block btn btn-default btn-lg ng-isolate-scope"> 
														<span class="btn-text-container"> 
															<span class="sms-btn-text">
																<span class="link-btn-label file-not-ready-text">{{$t('product.artworknotready')}}</span> 
																<span class="link-btn-anchor">{{$t('product.buynowuploadlater')}}</span>
															</span> 
														</span> 
													</button>
												</div>
											</div>
											<div class="sms-wgt-btn ffr-btn-container">
												<div class="button-wrapper">
													<button class="link-display ffr-btn site-btn-secondary-no-radius display-block btn btn-default btn-lg ng-isolate-scope">
														<span class="btn-text-container">
															<img src="../../assets/images/cxwj.png" class="b-icon"/>
															<span class="sms-btn-text">
																<span class="link-btn-anchor">{{$t('product.startwithaFREEProof')}}</span>
															</span> 
														</span>
													</button>
												</div>
											</div>
											<div class="ng-isolate-scope ng-shipping-inner">
												<div class="comp-product-shipping-container">
													<div class="shipping-heading-container">
														<a class="shipping-heading-link ng-scope">
															<img src="../../assets/images/cart.png" class="b-icon"/>
															<span class="heading-label site-secondary-link-italic">{{$t('product.estimateshippingdelivery')}}</span>
														</a>
													</div>
												</div>
											</div>
										</div>
									</div> -->
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="product-features-mobile-container visible-sm visible-xs container" v-if="isMobile">
					<h3 class="features-heading">{{$t('product.features')}}</h3>
					<div class="gallery-product-region">
						<div class="sms-wgt-text-image scroll-lazy wgt-txt-list_styles-check_list_primary wgt-txt-list_display_styles-list_group_inline lazy-loaded">
							<div class="wgt-text-content">
								<ul><li><span v-for="(item,index) in productInfos.featureTags">{{item}}</span></li></ul>
							</div>
						</div>
					</div>
				</div>
				<div class="product-details-container">
					<div class="comp-product-details-container ng-scope">
						<div class="product-tabs-navigation-container" >
							<ul class="product-details-tab-heading site-nav-tabs nav nav-tabs flux">
							    <li class="nav-list" :class="activeSection == 'overviewWrapper' ? 'active' : ''">
									<a class="js-product-details-focus" href="javascript:void(0)" @click="scrollTo('overviewWrapper')">
										<div class="sms-wgt-text-image scroll-lazy wgt-txt-styles-tab_heading_label lazy-loaded">
							                <div class="wgt-text-title">
												<span>{{$t('product.overview')}}</span>
											</div>
							            </div>
									</a>
							    </li>
							    <li class="nav-list" :class="activeSection == 'noticeWrapper' ? 'active' : ''">
									<a class="js-product-details-focus" href="javascript:void(0)" @click="scrollTo('noticeWrapper')">
										<div class="sms-wgt-text-image scroll-lazy wgt-txt-styles-tab_heading_label lazy-loaded">
							                <div class="wgt-text-title">
												<span>{{$t('footer.notesforcompletion')}}</span>
											</div>
							            </div>
									</a>
								</li>
							    <li class="nav-list" :class="activeSection == 'stepsWrapper' ? 'active' : ''">
									<a class="js-product-details-focus" href="javascript:void(0)" @click="scrollTo('stepsWrapper')">
										<div class="sms-wgt-text-image scroll-lazy wgt-txt-styles-tab_heading_label lazy-loaded">
											<div class="wgt-text-title">
												<span>{{$t('product.orderingprocess')}}</span>
											</div>
							            </div>
									</a>
							    </li>
							    <li class="nav-list" :class="activeSection == 'questionWrapper' ? 'active' : ''">
									<a class="js-product-details-focus" href="javascript:void(0)" @click="scrollTo('questionWrapper')">
										<div class="sms-wgt-text-image scroll-lazy wgt-txt-styles-tab_heading_label lazy-loaded">
											<div class="wgt-text-title">
												<span>{{$t('product.precautions')}}</span>
											</div>
							            </div>
									</a>
							    </li>
								<li class="nav-list" :class="activeSection == 'customerWrapper' ? 'active' : ''">
									<a class="js-product-details-focus" href="javascript:void(0)" @click="scrollTo('customerWrapper')">
										<div class="sms-wgt-text-image scroll-lazy wgt-txt-styles-tab_heading_label lazy-loaded">
											<div class="wgt-text-title">
												<span>{{$t('product.aftersalesservice')}}</span>
											</div>
								        </div>
									</a>
								</li>
							</ul>
						</div>
						<div id="overviewWrapper" class="overview-tab-wrapper content-tab-wrapper">
							<div class="mobile-product-tabs">
								<a class="js-product-details-focus">
							        <div class="sms-wgt-text-image scroll-lazy wgt-txt-styles-tab_heading_label lazy-loaded">
							            <div class="wgt-text-title">
							                <span>{{$t('product.overview')}}</span>
										</div>
							        </div>
								</a>
							</div>
							<div class="overview-tab-content tab-content container">
								<div class="elementor-widget-container">
									<table class="woocommerce-product-attributes shop_attributes">
										<tbody>
											<tr v-for="(item,index) in attributeData" :key="index" class="woocommerce-product-attributes-item woocommerce-product-attributes-item--attribute_pa_size">
												<th class="woocommerce-product-attributes-item__label" scope="row">
													<span class="wd-attr-name">
														<span class="wd-attr-name-label">{{item.groupName}}</span>
													</span>
												</th>
												<td class="woocommerce-product-attributes-item__value">
													<span class="wd-attr-term">
														<p>
															<template v-for="(attribute,attributeIndex) in item.productAttributeGroupI18nValueList">
																{{attribute.attributeValue}},
															</template>
														</p>
													</span>
												</td>
											</tr>
											
											<!-- <tr class="woocommerce-product-attributes-item woocommerce-product-attributes-item--attribute_pa_size">
												<th class="woocommerce-product-attributes-item__label" scope="row">
													<span class="wd-attr-name">
														<span class="wd-attr-name-label">预计发货</span>
														<el-tooltip class="item" effect="dark" content="下单次日起算，周六日以及美国公众假期不计算其中，完成支付并确认稿件无误方为下单完成" placement="top">
														    <span class="wd-hint wd-tooltip wd-tooltip-inited"></span>
														</el-tooltip>
														
													</span>
												</th>
												<td class="woocommerce-product-attributes-item__value">
													<span class="wd-attr-term">
														<p>3到5个工作日</p>
													</span>
												</td>
											</tr> -->
										</tbody>
									</table>
								</div>
								<div class="elementor-divider"></div>
								<div class="overview-product-region">
									 <div v-html="productInfos.remark"></div>
								</div>
							</div>
						</div>
						<div id="noticeWrapper" class="content-tab-wrapper">
							<!-- <div class="mobile-product-tabs">
								<a class="js-product-details-focus">
							        <div class="sms-wgt-text-image scroll-lazy wgt-txt-styles-tab_heading_label lazy-loaded">
							            <div class="wgt-text-title">
							                <span>完稿须知</span>
										</div>
							        </div>
								</a>
							</div> -->
							<div class="overview-tab-content tab-content container">
								<div class="overview-product-region">
									<h2>{{$t('footer.notesforcompletion')}}</h2>
									<div class="customer-trust-container scroll-lazy lazy-loaded">
										<div class="sms-wgt-list list-type-3colcath ">
											<div class="comp-3col-catalog-list-item-container wgt-list-group-container scroll-lazy lazy-loaded">
												<div class="wgt-list-item-container" v-for="(item,index) in noticeList">
													<div class="wgt-list-outline">
														<div class="wgt-list-item-image">
															<img :src="item.img" class="img-responsive"/>
														</div>
														<div class="wgt-list-item-desc-container">
															<div class="wgt-list-item-title">{{item.title}}</div>
															<div class="wgt-list-item-description">{{item.remark}}</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									
								</div>
							</div>
						</div>
						<div id="stepsWrapper" class="content-tab-wrapper">
							<div class="overview-tab-content tab-content container">
								<div class="overview-product-region">
									<h2>{{$t('product.orderingprocess')}}</h2>
									<span>{{$t('product.orderingprocesssubtitle')}}</span>
									<div class="order-process-container">
										<div class="process-block" v-for="(item,index) in orderProgress">
											<img :src="item.img" class="step-icon"/>
											<div class="step-txt">{{item.title}}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div id="questionWrapper" class="content-tab-wrapper">
							<div class="overview-tab-content tab-content container">
								<div class="overview-product-region">
									<h2>{{$t('product.QA')}}</h2>
									<div v-html="precautions"></div>
									<!-- <div class="comp-faq-container accordion">
										<div class="panel-group">
											<div class="panel" v-for="(item,index) in questionList" :key="index">
												<div class="cta-accordion" :class="item.collapsed ? '' : 'collapsed'" @click="changeCollase(index)" role="button">
													<span class="faq-question-legend">问：</span>
													<span class="faq-question">{{item.question}}</span>
													<img src="../../assets/images/minus.png" class="faq-question-icon plus-icon" v-if="item.collapsed"/>
													<img src="../../assets/images/plus.png" class="faq-question-icon plus-icon" v-else/>
												</div>
												<div class="faq-answer collapsed collapse" :class="item.collapsed ? 'in' : ''" :style="{height:(item.collapsed ? '' : '8px' ) }">
													<div v-html="item.answer"></div>
												</div>
											</div>
										</div>
									</div> -->
								</div>
							</div>
						</div>
						<div id="customerWrapper" class="content-tab-wrapper">
							<!-- <div class="mobile-product-tabs">
								<a class="js-product-details-focus">
							        <div class="sms-wgt-text-image scroll-lazy wgt-txt-styles-tab_heading_label lazy-loaded">
							            <div class="wgt-text-title">
							                <span>售后服务</span>
										</div>
							        </div>
								</a>
							</div> -->
							<div class="overview-tab-content tab-content container">
								<div class="overview-product-region">
									<h2 >{{$t('product.aftersalesservice')}}</h2>
									<div v-html="afterSalesService"></div>
									<!-- <div class="adaptive-img">
										<img src="../../assets/images/refund-policy-e1681219999567.jpg" />
									</div> -->
								</div>
							</div>
						</div>
						<div class="section-wrapper ng-scope">
							<div class="reviews-tab-wrapper content-tab-wrapper container">
								<div class="ratings-reviews-product-region">
									<div class="product-reviews-wrapper js-product-reviews-container">
										<div class="comp-review-widget-container">
											<div class="review-header">{{$t('product.reviews2')}}</div>
											<div class="review-summary js-review-summary">
												<div class="comp-overall-rating-box-container">
													<div class="rating">{{productInfos.startype}}</div>
													<div class="out-of">{{$t('product.outof')}} 5.0</div>
												</div>
												<div class="comp-overall-star-rating-container">
													<div class="overall-label">{{$t('product.overallrating')}}</div>
													<div class="overall-star comment-star-block">
														<img src="../../assets/images/star2.png" v-for="item in Number(productInfos.startype)"/>
														<img src="../../assets/images/star1.png" v-if="Number(productInfos.startype) < 5" v-for="item in (5 - Number(productInfos.startype))"/>
													</div>
												</div>
											</div>
											<div class="review-body">
												<div class="review-list js-review-list">
													<div class="comp-review-list-container scroll-lazy lazy-loaded">
														<div class="review-list-item" v-for="(item,index) in commentData" :key="index">
															<div class="star-rating">
																<div class="ratings-in-stars comp-ratings-in-stars-container">
																	<img src="../../assets/images/star2.png" class="s-star-icon" v-for="star in Number(item.fraction)"/>
																	<img src="../../assets/images/star1.png" class="s-star-icon" v-if="Number(item.fraction) < 5" v-for="star in (5 - Number(item.fraction))" />
																</div>
																<span class="review-heading">{{item.title}}</span>
															</div>
															<div class="review-badges">
																<span class="verified-buyer">
																	<img src="../../assets/images/user.png" class="c-user-icon"/>
																	{{$t('product.verifiedbuyer')}}
																</span>
															</div>
															<div class="review-info">
																<span class="review-date">{{item.createTime}} </span>
																<span class="review-user">{{$t('product.by')}}{{item.author}}</span>
															</div>
															<div class="review-message">{{item.content}}</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="customer-trust-container scroll-lazy lazy-loaded">
					<div class="customer-trust-region container">
						<div class="sms-wgt-list list-type-3colcath ">
							<div class="wgt-list-title">{{$t('customerTrust.title')}}</div>
							<div class="wgt-list-description">{{$t('customerTrust.subtitle')}}</div>
							<div class="comp-3col-catalog-list-item-container wgt-list-group-container scroll-lazy lazy-loaded">
								<div class="wgt-list-item-container">
									<div class="wgt-list-outline">
										<div class="wgt-list-item-image">
											<img src="../../assets/images/Freefilechecks.svg" class="img-responsive lazy-loaded"/>
										</div>
										<div class="wgt-list-item-desc-container">
											<div class="wgt-list-item-title">{{$t('customerTrust.title1')}}</div>
											<div class="wgt-list-item-description">
												<p>{{$t('customerTrust.remark1')}}</p>
											</div>
										</div>
									</div>
								</div>
								<div class="wgt-list-item-container">
									<div class="wgt-list-outline">
										<div class="wgt-list-item-image">
											<img src="../../assets/images/More Printings.svg" class="img-responsive lazy-loaded"/>
										</div>
										<div class="wgt-list-item-desc-container">
											<div class="wgt-list-item-title">{{$t('customerTrust.title2')}}</div>
											<div class="wgt-list-item-description">
												<p>{{$t('customerTrust.remark2')}}</p>
											</div>
										</div>
									</div>
								</div>
								<div class="wgt-list-item-container">
									<div class="wgt-list-outline">
										<div class="wgt-list-item-image">
											<img src="../../assets/images/Reliables.svg" class="img-responsive lazy-loaded"/>
										</div>
										<div class="wgt-list-item-desc-container">
											<div class="wgt-list-item-title">{{$t('customerTrust.title3')}}</div>
											<div class="wgt-list-item-description">
												<p>{{$t('customerTrust.remark3')}}</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="comp-sticky-calc-price-container ng-scope">
					<div class="sticky-calc-price-container loaded" style="width: 100vw;">
						<div class="sticky-calc-wrapper">
							<div class="price-container ng-scope">
								<span class="h5 ng-scope">{{$t('product.printingcost')}}</span>
								<div class="sticky-price">
									<div class="subtotal-wrapper">
										<span class="original-price ng-binding ng-scope" v-if="lang == 'zh'">{{skuPrice}} 美元</span>
										<span class="original-price ng-binding ng-scope" v-else>${{skuPrice}}</span>
									</div>
								</div>
							</div>
							<div class="upload-btn-container">
								<button @click="addCart" class="upload-btn site-btn-secondary-no-radius ng-scope ng-isolate-scope">
									<span class="btn-text-container">{{$t('product.addtocart')}}</span>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<footers></footers>
		<div class="z-block"></div>
		<loginModal ref="loginRef" :isShow="showLoginModal" @closeLoinMadal="closeLoinMadal"></loginModal>
		<div v-if="openSelect && isMobile" class="modal-backdrop fade ng-scope in" style="z-index: 1040;"></div> 
		<loading v-if="isLoading"></loading>
	</div>
</template>

<script>
	import headerNavigation from '../../components/headerNavigation.vue'
	import footers from '../../components/footers.vue'
	import loginModal from '../../components/loginModal.vue'
	import loading from '../../components/loading.vue'
	import {queryProductInfo,uploadFile,queryorderprocess,addCart,commentList} from '../../api/api.js'
	export default {
		components: {
			headerNavigation,
			footers,
			loginModal,
			loading
		},
		data() {
			return {
				isMobile: false,
				showLoginModal: false,
				swiperList: [],
				dotIndex: 0,
				openSelect:false,
				contents:``,
				questionList:[{
					question:'您使用什么类型的纸张？',
					answer:`<p><span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">您可以选择使用</font></font></span><span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">70-100</font></font></span> <span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">磅纸张或 14/16 磅卡片纸打印堂食菜单。您还可以选择哑光或光面涂层</font></font></span><span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">。</font></font></span></p>`,
					collapsed:false
				},
				{
					question:'你们进行正面和背面印刷吗？',
					answer:`<p><span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">您可以选择使用</font></font></span><span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">70-100</font></font></span> <span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">磅纸张或 14/16 磅卡片纸打印堂食菜单。您还可以选择哑光或光面涂层</font></font></span><span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">。</font></font></span></p>`,
					collapsed:false
				},
				{
					question:'菜单手册可以有多少页？',
					answer:`<p><span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">您可以选择使用</font></font></span><span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">70-100</font></font></span> <span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">磅纸张或 14/16 磅卡片纸打印堂食菜单。您还可以选择哑光或光面涂层</font></font></span><span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">。</font></font></span></p>`,
					collapsed:false
				},
				{
					question:'菜单的打印时间是多长时间？',
					answer:`<p><span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">您可以选择使用</font></font></span><span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">70-100</font></font></span> <span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">磅纸张或 14/16 磅卡片纸打印堂食菜单。您还可以选择哑光或光面涂层</font></font></span><span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">。</font></font></span></p>`,
					collapsed:false
				}],
				activeSection:'overviewWrapper',
				owlBoxWidth:0,
				owlItenWidth:0,
				isDragging:false,
				productNo:"",
				productInfos:{},
				isLoading:false,
				attributeData:[],
				skuMap: [], // 商品 SKU Map
				attrValue: '', // 已选属性名的拼接
				attrSKU: [],//选中的 SKU
				skuPrice:0,//规格价格
				lang:'',
				selectedFile:null,
				designDraftList:[],
				mobileSwiperStyle:'margin-right: 16px;',
				orderProgress:[],
				precautions:'',
				noticeList:[],
				afterSalesService:'',
				skuCode:'',
				commentData:[]
			};
		},
		mounted() {
		    // 添加滚动监听
		    window.addEventListener('scroll', this.handleScroll);
		},
		beforeDestroy() {
		    // 移除滚动监听
		     window.removeEventListener('scroll', this.handleScroll);
		},
		created() {
			this.isMobile = this.webIsMobile()
			this.lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';
			this.scrollToTop()
			if(this.$route.query.no){
				this.productNo = this.$route.query.no;
			}
			this.init()
			this.queryorderprocess()
			this.commentList()
		},
		methods: {
			init(){
				var that = this;
				let params = {
					productNo:this.productNo
				}
				this.isLoading = true
				queryProductInfo(params).then(res => {
					that.isLoading = false
					if (res.code == 200) {
						that.productInfos = res.data.productItem
						const regex = new RegExp('<img', 'gi');
						if(that.productInfos.remark){
							that.productInfos.remark = that.productInfos.remark.replace(regex, `<img style="width: 100%;margin:0 auto;"`);
						}
						that.attributeData = res.data.alist[0].productAttributeGroupI18nList
						that.attrValue = ''
						that.attrSKU = []
						if(that.attributeData.length > 0){
							that.attributeData.forEach((item) => {
								if(item.productAttributeGroupI18nValueList.length > 0){
									// that.attrSKU.push(item.productAttributeGroupI18nValueList[0].attributeKey)
									that.attrSKU.push({
										key:item.groupName,
										value:item.productAttributeGroupI18nValueList[0].attributeValue,
										valueCode:item.productAttributeGroupI18nValueList[0].attributeKey
									})
									that.attrValue = that.attrValue + item.productAttributeGroupI18nValueList[0].attributeKey
								}else{
									// that.attrSKU.push('')
									that.attrSKU.push({
										key:'',
										value:'',
										valueCode:'',
									})
								}
							})
						}
						if(res.data.productItem.img){
							that.swiperList = res.data.productItem.img.split(",");
							that.$nextTick(() => {
								that.calculateSwiper()
							})
						}
						that.skuMap = res.data.skulist
						that.getSkuPrice()
					}
					
				})
			},
			queryorderprocess(){
				var that = this;
				let params = {}
				queryorderprocess(params).then(res => {
					if (res.code == 200) {
						const regex = new RegExp('<img', 'gi');
						if(res.data.precautionslist[0].remark){
							that.precautions = res.data.precautionslist[0].remark.replace(regex, `<img style="width: 100%;margin:0 auto;"`);
						}
						// that.precautions = res.data.precautionslist[0].remark
						that.orderProgress = res.data.orderlclist
						that.noticeList = res.data.wgaolist
						if(res.data.aftersalesservicelist[0].remark){
							that.afterSalesService = res.data.aftersalesservicelist[0].remark.replace(regex, `<img style="width: 100%;margin:0 auto;"`);
						}
						//that.afterSalesService = res.data.aftersalesservicelist[0].remark
					}
				})
			},
			commentList(){
				var that = this;
				let params = {
					productNo:this.productNo
				}
				commentList(params).then(res => {
					if (res.code == 200) {
						that.commentData = res.data
					}
				})
			},
			openLoginMadal() {
				this.showLoginModal = true
				this.changeRegister(false)
			},
			closeLoinMadal() {
				this.showLoginModal = false
			},
			changeRegister(e) {
				this.$refs.loginRef.changeRegisterType(e)
				this.showLoginModal = true
			},
			changeSelectExpand(){
				this.openSelect = !this.openSelect
			},
			closeSelectExpand(){
				this.openSelect = false
			},
			changeCollase(e){
				this.questionList[e].collapsed = !this.questionList[e].collapsed
			},
			scrollTo(id) {
			   const element = document.getElementById(id);
			    if (element) {
			        element.scrollIntoView({ 
			            behavior: 'smooth',
			            block: 'start'
			        });
			        this.activeSection = id;
			    }
			    this.activeSection = id;
			},
			calculateSwiper(){
				var outList = this.$refs.owllist
				const innerwidth = outList.offsetWidth;
				const ultimatelyWidth = innerwidth - (4 * 13)//扣除边距
				var width = Math.ceil(ultimatelyWidth / 4) 
				var outbox = this.$refs.owlBox
				this.mobileSwiperStyle = `width:${width}px;margin-right: 16px;`
				var boxwidth = this.swiperList.length * (width + 17)
				outbox.style = `width:${boxwidth}px;transform: translate3d(0px, 0px, 0px);transition: 0.25s;`
				this.owlBoxWidth = boxwidth
				this.owlItenWidth = width
			},
			swiperPrev(){
				var that = this
				if(this.dotIndex < this.swiperList.length && this.dotIndex > 0){
					var outbox = this.$refs.owlBox
					var itemWidth = this.owlItenWidth + 13
					var boxwidth = this.owlBoxWidth
					if(this.dotIndex == 1){
						this.dotIndex = 0
						outbox.style = `transform: translate3d(0px, 0px, 0px); transition: 0.25s;width:${boxwidth}px;`
					}else{
						this.dotIndex = this.dotIndex - 1
						var transform = this.dotIndex * itemWidth
						outbox.style = `transform: translate3d(-${transform}px, 0px, 0px); transition: 0.25s;width:${boxwidth}px;`
					}
				}
			},
			swiperNext(){
				var that = this
				if(this.dotIndex < this.swiperList.length - 4){
					var outbox = this.$refs.owlBox
					
					var itemWidth = this.owlItenWidth + 13
					var boxwidth = this.owlBoxWidth
					this.dotIndex = this.dotIndex + 1
					var transform = this.dotIndex * itemWidth
					outbox.style = `transform: translate3d(-${transform}px, 0px, 0px); transition: 0.25s;width:${boxwidth}px;`
				}
			},
			selectSwiper(e){
				var that = this
				var oldIndex = this.dotIndex
				this.dotIndex = e
				if(oldIndex < this.swiperList.length - 4){
					var outbox = this.$refs.owlBox
					
					var itemWidth = this.owlItenWidth + 13
					var boxwidth = this.owlBoxWidth
					var transform = this.dotIndex * itemWidth
					outbox.style = `transform: translate3d(-${transform}px, 0px, 0px); transition: 0.25s;width:${boxwidth}px;`
				}
			},
			handleTouchStart(e) {
			    this.isDragging = true;
				var outbox = this.$refs.owlBox
				outbox.setAttribute('data-startX', e.touches[0].clientX);
				outbox.setAttribute('data-currentX', outbox.getAttribute('data-translateX'));
			},
			handleTouchMove(e) {
			    if (!this.isDragging) return;
				
				var outbox = this.$refs.owlBox
				const boxwidth = this.owlBoxWidth;
				
				const currentX = e.touches[0].clientX;
				const diffX = currentX - Number(outbox.getAttribute('data-startX'));
				
				const newTranslateX = Number(outbox.getAttribute('data-currentX')) + diffX;
				
				const minTranslate = -(boxwidth - (this.owlItenWidth * 4)); 
				
				if (newTranslateX > 0 || newTranslateX < minTranslate) {
				    
				} else {
					if(newTranslateX >= -20){
						outbox.setAttribute('data-translateX', 0);
						outbox.style = `width:${boxwidth}px;transform: translate3d(0px, 0px, 0px); transition: 0.25s;`
					}else{
						outbox.setAttribute('data-translateX', newTranslateX);
						outbox.style = `width:${boxwidth}px;transform: translate3d(${newTranslateX}px, 0px, 0px); transition: 0.25s;`
					}
					
				}
			},
			handleTouchEnd(catIndex, e) {
			    if (!this.isDragging) return;
			    this.isDragging = false;
			},
			selectSku(index,attribute){
				//this.$set(this.attrSKU,index,attribute.attributeKey)
				this.$set(this.attrSKU[index],'valueCode',attribute.attributeKey)
				this.$set(this.attrSKU[index],'value',attribute.attributeValue)
				var attrSKUVal = ''
				this.attrSKU.forEach((item) => {
					attrSKUVal = attrSKUVal + item.valueCode
				})
				this.attrValue = attrSKUVal
				this.getSkuPrice()
			},
			getSkuPrice(){
				this.skuMap.forEach((item,index) => {
					if(this.attrValue == item.codes){
						this.skuPrice = item.price
						this.skuCode = item.skuCode
					}
				})
			},
			onFileChange(e) {
			    this.selectedFile = e.target.files[0];
				this.uploadImage()
			},
			uploadImage() {
			    const formData = new FormData();
			    formData.append('file', this.selectedFile, this.selectedFile.name);
			    var that = this;
				
			    let params = formData
				this.isLoading = true
			    uploadFile(params).then(res => {
					that.isLoading = false
			    	if (res.code == 200) {
			    		that.designDraftList.push(res.data.url)
			    	}else{
						that.$message.error(res.msg);
					}
			    })
			},
			delDesign(index){
				this.designDraftList.splice(index, 1);
			},
			addCart(){
				var that = this;
				var designImg = ''
				if(this.designDraftList.length > 0){
					this.designDraftList.forEach(item => {
						designImg = designImg + item + ',';
					});
					if(designImg){
						designImg = designImg.substring(0, designImg.length - 1);
					}
				}
				
				let params = {
					productId:this.productInfos.productId,
					skulist:this.attrSKU,
					unitPrice:this.skuPrice,
					productNum:1,
					skucode:this.skuCode,
					fileurl:designImg
				}
				this.isLoading = true
				addCart(params).then(res => {
					that.isLoading = false
					if (res.code == 200) {
						that.$refs.headerRef.queryCartQty()
						that.$message.success(res.msg);
					}else{
						that.$message.error(res.msg);
					}
				})
			}
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/detail.css");
	.global-header-spacer {
	    height: 50px !important;
	    display: block !important;
	}
</style>
